import type { SearchSchemaInput } from '@tanstack/react-router'
import { z } from 'zod'

import { GAME_OPTIONS, type GameType } from '@/types/pack'

const games = GAME_OPTIONS.map(option => option.value) as [GameType, ...GameType[]]

const schema = z.object({
    game: z.enum(games).catch('pokemon'),
    tab: z.enum(['blueprints', 'live']).catch('blueprints')
})

export type PacksSearch = z.infer<typeof schema>

/**
 * Only the two axes that decide what is on screen. The per-tab filters stay in
 * component state here rather than in the URL: both lists are small enough to filter
 * client-side or refetch instantly, and a URL carrying two tabs' worth of filters is
 * one nobody can read.
 */
export function parsePacksSearch(search: { game?: unknown; tab?: unknown } & SearchSchemaInput): PacksSearch {
    return schema.parse(search ?? {})
}
